import React from 'react';
import PropTypes from 'prop-types';
import Color from 'color';
import { nanoid } from 'nanoid';

import FONT_FAMILY from '../../../constants/fontFamily';
import FontFamilyHeader from '../../FontFamilyHeader';
import useCountdown from '../useCountdown';
import BrickBackground from './wall.jpg';
import { Container, Time, Title } from './styles';

function CountdownNeonSimple({ data, styles }) {
  const haveTitle = !!data.title;

  const fontFamilyTimer = FONT_FAMILY[styles?.timer?.font || 'vibur'];
  const fontFamilyTitle = FONT_FAMILY[styles?.title?.font || 'vibur'];

  const [hours, minutes, seconds] = useCountdown({
    audioUrl: data.audioUrl,
    status: data.status,
    time: data.time,
  });

  return (
    <>
      <FontFamilyHeader family={fontFamilyTimer} />
      <FontFamilyHeader family={fontFamilyTitle} />
      <Container
        img={BrickBackground}
        hasBackground={styles?.background?.hasBackground}
        style={{ borderRadius: styles?.background?.borderRadius }}
      >
        {haveTitle && (
          <Title
            style={{
              color: Color(styles?.title?.color).lighten(0.95),
              fontFamily: fontFamilyTitle?.family,
              fontSize: styles?.title?.size,
              letterSpacing: styles?.title?.letterSpacing,
              lineHeight: styles?.title?.size
                ? `${styles?.title?.size}px`
                : undefined,
              textShadow: `0 0 2px, 0 0 1em ${styles?.title?.color}, 0 0 0.5em ${styles?.title?.color},
              0 0 0.1em ${styles?.title?.color}, 0 10px 3px #000`,
            }}
          >
            {Array.from(data.title).map((char, index) => {
              return (
                <span
                  key={nanoid(10)}
                  className="blink"
                  style={{
                    animationDuration: `${Math.floor(
                      Math.random() * (60 - 8 + 1) + 8
                    )}s`,
                  }}
                >
                  {char}
                </span>
              );
            })}
          </Title>
        )}
        <Time
          style={{
            color: Color(styles?.timer?.color).lighten(0.95),
            fontFamily: fontFamilyTimer?.family,
            fontSize: styles?.timer?.size,
            letterSpacing: styles?.timer?.letterSpacing,
            lineHeight: styles?.timer?.size
              ? `${styles?.timer?.size}px`
              : undefined,
            textShadow: `0 0 2px, 0 0 1em ${styles?.timer?.color}, 0 0 0.5em ${styles?.timer?.color},
              0 0 0.1em ${styles?.timer?.color}, 0 10px 3px #000`,
          }}
        >
          {`${hours}:${minutes}:${seconds}`}
        </Time>
      </Container>
    </>
  );
}

CountdownNeonSimple.propTypes = {
  data: PropTypes.shape({
    audioUrl: PropTypes.string,
    status: PropTypes.string,
    time: PropTypes.arrayOf(PropTypes.number),
    title: PropTypes.string,
  }),
  styles: PropTypes.shape({
    background: PropTypes.shape({
      hasBackground: PropTypes.bool,
    }),
    timer: PropTypes.shape({
      color: PropTypes.string,
      font: PropTypes.string,
      letterSpacing: PropTypes.number,
      size: PropTypes.number,
    }),
    title: PropTypes.shape({
      color: PropTypes.string,
      font: PropTypes.string,
      letterSpacing: PropTypes.number,
      size: PropTypes.number,
    }),
  }),
};

CountdownNeonSimple.defaultProps = {
  data: {
    audioUrl: null,
    status: 'paused',
    time: [],
    title: 'Time Remaining',
  },
  styles: {
    background: {
      borderRadius: 10,
      hasBackground: true,
    },
    timer: {
      color: '#2222C3',
      font: 'vibur',
      letterSpacing: 2,
      size: 70,
    },
    title: {
      color: '#2222C3',
      font: 'vibur',
      letterSpacing: 2,
      size: 40,
    },
  },
};

export default CountdownNeonSimple;
